import { useMemo } from 'react'

import { useCatalogueProducts } from 'modules/products'
import type { ProductsFeedPage } from 'typings/graphql'

import useCollaborationCatalogueId from './useCollaborationCatalogueId'


type UseCollaborationProductsProps = {
  catalogueType: CollaborationsModule.CatalogueType
  collaboration: CollaborationsModule.Collaboration
  excludeId?: number
  fetchPolicy?: 'cache-and-network'
  limit?: number
  productsFeed?: ProductsFeedPage
  skip?: boolean
}

const useCollaborationProducts = ({ catalogueType, collaboration, excludeId, fetchPolicy, limit, productsFeed, skip }: UseCollaborationProductsProps) => {
  const { catalogueId, isFetching: isFetchingCatalogueId } = useCollaborationCatalogueId({
    catalogueType,
    collaboration,
    skip,
  })

  const { data: rawProducts, isFetching: isFetchingProducts } = useCatalogueProducts({
    variables: {
      id: catalogueId,
      input: {
        limit: excludeId ? limit + 1 : limit,
        productsFeed,
      },
    },
    fetchPolicy,
    skip: skip || !catalogueId,
  })

  const products = useMemo(() => {
    return rawProducts?.products?.filter((product) => {
      const { id } = product

      return id !== excludeId
    }).slice(0, limit)
  }, [ excludeId, limit, rawProducts ])

  return {
    data: products,
    isFetching: isFetchingCatalogueId || isFetchingProducts,
  }
}

export default useCollaborationProducts
